<!---- Copyright The Linux Foundation and each contributor to LFX.-->
<!---- SPDX-License-Identifier: MITs -->
<!-- begin #sidebar-right -->
<div id="sidebar-right" class="sidebar sidebar-right">
    <div class="iframe-loader">
        <iframe height="100%" width="100%" [src]="url" name="help-support-frame"></iframe>
    </div>
</div>
<!-- end #sidebar-right -->
